import { ITransactions } from "features/Crm/modules/Transactions/Transactions.interfaces";
import { getMaskedAadhaar } from "utils/aadhaar";
import { AADHAAR_NUMBER_LABEL } from "constants/transactions.constants";
import React from "react";

export const KYCDetailsField = ({
  answers,
  aadhaarNumber,
}: {
  answers: ITransactions.BookingResponse["answer_list"];
  aadhaarNumber?: string | null;
}) => {
  const maskedAadhaar = getMaskedAadhaar(aadhaarNumber);

  return (
    <div className="tw-text-sm">
      {answers.map(({ question, answer }) => (
        <div key={question}>
          <strong>{question}</strong>: {answer}
        </div>
      ))}
      {maskedAadhaar && (
        <div>
          <strong>{AADHAAR_NUMBER_LABEL}</strong>: {maskedAadhaar}
        </div>
      )}
    </div>
  );
};
